import { text, type Variants } from './style'

export interface TextProps extends Variants {
  className?: string
  children?: React.ReactNode
  'data-testid'?: string
}

export function Text({
  children,
  size,
  font,
  color,
  block,
  className,
  'data-testid': testId,
}: TextProps) {
  return (
    <span className={text({ size, font, color, block, className })} data-testid={testId}>
      {children}
    </span>
  )
}
